import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";

const HERO_IMG =
  "https://images.unsplash.com/photo-1643904736472-8b77e93ca3d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/85 to-black" />
      <div className="absolute inset-0 brand-texture opacity-40" />

      <motion.div
        variants={stagger}
        initial="hidden"
        animate="show"
        className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-20"
      >
        <motion.p
          variants={fadeUp}
          data-testid="hero-overline"
          className="font-mono-accent text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#737373] mb-8"
        >
          Institutional Services · Dubai Mainland
        </motion.p>

        <motion.h1
          variants={fadeUp}
          data-testid="hero-heading"
          className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] font-medium tracking-tighter leading-[0.98] text-white max-w-5xl"
        >
          Institutional-grade CFD &amp; wholesale services for the world&apos;s brokers.
        </motion.h1>

        <motion.p
          variants={fadeUp}
          data-testid="hero-subheading"
          className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-[#A3A3A3]"
        >
          Wolf Land Investment LLC partners with institutional brokerages to deliver
          liquidity access, B2B client introductions, market intelligence and
          structured education — with absolute discretion.
        </motion.p>

        <motion.div variants={fadeUp} className="mt-12 flex flex-wrap items-center gap-4">
          <a
            href="#services"
            data-testid="hero-primary-cta"
            className="font-mono-accent text-[12px] tracking-[0.14em] uppercase px-8 py-4 bg-white text-black hover:text-[#00FFD1] transition-colors duration-300"
          >
            Explore Services
          </a>
          <a
            href="#contact"
            data-testid="hero-secondary-cta"
            className="font-mono-accent text-[12px] tracking-[0.14em] uppercase px-8 py-4 border border-white/25 text-white hover:text-[#00FFD1] hover:border-[#00FFD1] transition-colors duration-300"
          >
            Request an Introduction
          </a>
        </motion.div>
      </motion.div>

      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/10 bg-black/40 backdrop-blur-sm overflow-hidden">
        <div className="marquee-track py-3">
          {["a", "b"].map((row) => (
            <div key={row} className="flex shrink-0">
              {["FX", "Indices", "Futures", "Digital Assets", "Liquidity", "B2B Introductions", "Managed Accounts", "Market Intelligence"].map(
                (t) => (
                  <span
                    key={`${row}-${t}`}
                    className="font-mono-accent text-[11px] tracking-[0.2em] uppercase text-[#737373] px-8"
                  >
                    {t} <span className="text-[#333] ml-8">/</span>
                  </span>
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
